module.exports = __webpack_public_path__ + "static/media/logo-global-brain.1584a644.png";